import { AxiosInstance } from 'axios';
import { OpenTaskListOwnerFilterInput, OpenTaskListParticipantFilterInput, OpenTaskListTeamFilterInput } from './input';
import { OpenTaskListResource } from './resources';
import qs from 'qs';

export default class OpenTaskList {
    private basePath = '/api/open-task-list';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Fetches by owner user ID
    getByOwnerUser = async (filter?: OpenTaskListOwnerFilterInput): Promise<OpenTaskListResource> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/user-space?${query}`);

        return data;
    };

    // Fetches by participant user ID
    getByParticipantUser = async (filter?: OpenTaskListParticipantFilterInput): Promise<OpenTaskListResource> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/participant?${query}`);

        return data;
    };

    // Fetches by team ID
    getByTeam = async (filter?: OpenTaskListTeamFilterInput): Promise<OpenTaskListResource> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/team?${query}`);

        return data;
    };
}
